import { useEffect, useState } from "react";
import { Channel } from "pusher-js";

import { useSocket } from "components";
import { ISocketService, useAccountIdSelector, useAccountSelector, useDataRoomsActions } from "store";

interface IMessage {
  message: string;
  code: string;
  countdown: string;
}

const eventName = "datarooms-sms";
const successSubscribeEvent = "pusher:subscription_succeeded";
const errorSubscribeEvent = "pusher:subscription_error";
const errorEvent = "error";

export function useDataroomsSocketHook() {
  const [channel, setChannel] = useState<Channel | null>(null);
  const { allow_dataroom } = useAccountSelector() || {};

  if (!allow_dataroom) return;

  const accountId: number | undefined = useAccountIdSelector();

  const { setConnectMessageAction, setConnectMessageTimeoutAction } = useDataRoomsActions();
  const socket: ISocketService = useSocket();

  const channelName = `private-datarooms-${accountId}`;

  const formatCountdown = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${minutes}:${secs}`;
  };

  useEffect(() => {
    setChannel(socket.subscribe(channelName));

    return () => {
      socket.unsubscribe(channelName);
    };
  }, [socket, channelName]);

  useEffect(() => {
    let countdownTimer: NodeJS.Timeout | null = null;

    if (channel) {
      channel.bind(eventName, (payload: IMessage) => {
        setConnectMessageAction({ ...payload, countdown: formatCountdown(300) });

        if (countdownTimer) {
          clearInterval(countdownTimer);
        }

        let countdown = 300;
        countdownTimer = setInterval(() => {
          countdown -= 1;
          if (countdown > 0) {
            setConnectMessageTimeoutAction(formatCountdown(countdown));
          } else {
            clearInterval(countdownTimer!);
            setConnectMessageTimeoutAction(null);
          }
        }, 1000);
      });

      channel.bind(successSubscribeEvent, () => {
        console.log("[Dataroom subscription success]");
      });

      channel.bind(errorSubscribeEvent, (error: any) => {
        console.log("[errorSubscribeEvent]: ", error);
      });

      channel.bind(errorEvent, (error: any) => {
        console.log("[errorEvent]: ", error);
      });

      return () => {
        console.log("Datarooms message - unbind");
        channel.unbind_all();
        if (countdownTimer) {
          clearInterval(countdownTimer);
        }
      };
    }
  }, [channel, accountId]);
}
